import React from 'react';

import PropTypes from 'prop-types';

import AddMedia from '../AddMedia';
import ColorButton from '../common/elements/ColorButton';


const AddMediaModalComponent = ({ isSubmitting, isValid, intl, onChange, onSubmit }) => (
  <div className="flex flex-col bg-white rounded-sm overflow-hidden">
    <div className="p-0">
      <AddMedia onChange={onChange} key="add-media" />
    </div>
    
    <div className="flex justify-end mt-[1.5em] p-0 px-4 pb-4">
      <ColorButton 
        type="button" 
        color="green" 
        disabled={!isValid} 
        isBusy={isSubmitting} 
        onClick={onSubmit}
        className="!m-0"
      >
        {intl.formatMessage({ id: 'SEND' })}
      </ColorButton>
    </div>
  </div>
);

AddMediaModalComponent.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  isValid: PropTypes.bool.isRequired,
  intl: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default AddMediaModalComponent;
